import React, { useEffect } from 'react';
import { Form, Input, Button, Select, List } from 'antd';
import { createCollaboration } from "../../features/collaboration/collaborationSlice";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { message as msg } from 'antd';
const { Option } = Select;

const CreateCollaboration = () => {
  const [messageApi, contextHolder] = msg.useMessage();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [options, setOptions] = React.useState([]);
  const [optionInput, setOptionInput] = React.useState("");
  const { isError, creating, message, isCreateSuccess } = useSelector((state) => state.collaboration);

  const onFinish = (values) => {
    const data = { ...values, options };
    dispatch(createCollaboration(data));
  };

  const addOption = () => {
    if (optionInput) {
      setOptions([...options, optionInput]);
      setOptionInput('');
    }
  };

  const removeOption = (index) => {
    const newOptions = options.filter((_, i) => i !== index);
    setOptions(newOptions);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      addOption();
    }
  };

  useEffect(() => {
    if (isError && message) {
      messageApi.open({
        type: 'error',
        content: message,
      });
    }

    if (isCreateSuccess) {
      messageApi.open({
        type: 'success',
        content: "Setting is updated successfully",
      });
    }

    if (isCreateSuccess) {
      navigate('/admin/collaboration');
    }
  }, [isError, message, isCreateSuccess, messageApi, navigate]);

  return (
    <div>
      {contextHolder}
      <h3 className="mb-4 title">Find A Collab</h3>
      <Form
        layout="vertical"
        onFinish={onFinish}
        initialValues={{ period: 'day', status: '1', type: 'collaboration'}}
      >
        <Form.Item
          label="Title"
          name="title"
          rules={[{ required: true, message: 'Please input the title!' }]}
        >
          <Input />
        </Form.Item>

        <Form.Item label="Options">
          <Input
            value={optionInput}
            onChange={(e) => setOptionInput(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Enter a option and press Enter"
          />
          <Button onClick={addOption} type="primary" style={{ marginTop: '10px' }}>
            Add Option
          </Button>
          <List
            size="small"
            bordered
            dataSource={options}
            renderItem={(item, index) => (
              <List.Item>
                {item}
                <Button type="link" onClick={(e) => {e.preventDefault(); removeOption(index);}}>Remove</Button>
              </List.Item>
            )}
            style={{ marginTop: '10px', padding: '10px' }}
          />
        </Form.Item>

        <Form.Item
          label="Status"
          name="status"
          rules={[{ required: true, message: 'Please select the status!' }]}
        >
          <Select>
            <Option value="1">Active</Option>
            <Option value="0">Inactive</Option>
          </Select>
        </Form.Item>
    
        <Form.Item>
          <Button type="primary" htmlType="submit" disabled={creating}>
            {creating? 'Submitting...' : 'Submit'}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default CreateCollaboration;
